module.exports = __webpack_public_path__ + "static/total-chaos-f274e818c9f3af312e5e898938dbfdab.jpg";